<!-- Иконка калькулятора для карточки калькулятора на главной. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect
      x="4"
      y="2"
      width="16"
      height="20"
      rx="2"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="8"
      y1="6"
      x2="16"
      y2="6"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="8"
      y1="10"
      x2="10"
      y2="10"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="14"
      y1="10"
      x2="16"
      y2="10"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="8"
      y1="14"
      x2="10"
      y2="14"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="14"
      y1="14"
      x2="16"
      y2="14"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="8"
      y1="18"
      x2="10"
      y2="18"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="14"
      y1="18"
      x2="16"
      y2="18"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "HomeCalculatorIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
